<template>
  <div>
    <v-btn
      @click="click"
      :style="{width:$vuetify.breakpoint.sm?'':width, 'max-width':'430px' }"
      :block="$vuetify.breakpoint.smAndDown"
      large
      :light="!dark"
      :dark="dark && !light"
      :color="color"
    >
      <v-row align="center">
      <v-col cols="2" class="pa-1">
        <img
          v-if="src !== ''"
          style="width:30px; height:30px;"
          :src="src"
        />
        <v-icon right v-else>{{icon}}</v-icon>
      </v-col>

      <v-col cols="9">
        <div style="flex-grow: 1;" class="body-2">
          {{$vuetify.breakpoint.xs || !label ?
              methodId :
                ($tf(label) + ' ' + methodId) }}</div>
      </v-col>
      </v-row>
    </v-btn>
    <div v-show="false" ref="slot">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import dialogs from '../../mixins/dialogs'

export default {
  name: 'login-with-button',
  props: {
    href: {
      type: [String],
      default: '#'
    },
    methodId: {
      type: [String],
      default: ''
    },
    idpId: {
      type: [String],
      default: ''
    },
    label: {
      type: [String],
      default: ''
    },
    icon: {
      type: [String],
      default: 'launch'
    },
    src: {
      type: [String],
      default: ''
    },
    width: {
      type: [String],
      default: '90%'
    },
    light: {
      type: [Boolean],
      default: false
    },
    dark: {
      type: [Boolean],
      default: false
    },
    color: {
      type: [String],
      default: ''
    },
    openMode: {
      type: [String],
      default: 'redirect'
    }
  },
  mixins: [dialogs],
  data () {
    return {
      hover: false
    }
  },
  computed: {},
  methods: {
    click (e) {
      e.stopPropagation()
      this.$axios.post('idp-id', { 'idp_id': this.idpId })
        .then((response) => {
          if (response.status !== 200) {
            let notOk = 'notOk'
            throw notOk
          }
          // eslint-disable-next-line no-constant-condition
          if (this.$refs.slot.childNodes.length > 0 && false) {
            let descendents = document.getElementsByClassName(this.methodId)[0].getElementsByTagName('div')
            for (let i = 0; i < descendents.length; ++i) {
              descendents[i].click()
            }
          } else {
            // TODO configurable open
            // TODO call idpID
            switch (this.openMode) {
              case 'popup':
                this.centeredPopup(this.href, this.label, '600', '400', true)
                break
              case 'newTab':
                window.open(this.href, '_blank')
                break
              default:
                window.location.href = this.href
            }
          }
        }).catch((error) => {
          this.$log.error(error)
          window.location.href = '/error?hl=' + this.locale + '&error_message=Unexpected'
        })
    }
  }
}
</script>

<style>
  .v-btn:hover:before {
    background-color: initial !important;
  }
  .v-btn {
    font-size: 14px !important;
  }
</style>
